import React from "react";
import "./customerSupport.css";

import SideNav from "../Components/sideNav";
import Navbar from "../Components/navbar";
import StatCards from "../Components/statCards";
import BigMultiBar from "./bigMultiBar";
import DonutChartBig from "./donutChartBig";
import CustomerTable from "./customerTable";

const CustomerSupport = () => {

  const statCardData = [
    {
      body: "12,750",
      head: "Queries Received",
      icon: "./images/PvxDashboard/StatCard/QueryRed.svg",
    },
    {
      body: "12,050",
      head: "Queries Resolved",
      icon: "./images/PvxDashboard/StatCard/Tick.svg",
    },
    {
      body: "700",
      head: "Calls",
      icon: "./images/PvxDashboard/StatCard/CallsBlue.svg",
    },
    {
      body: "3000",
      head: "Feedbacks",
      icon: "./images/PvxDashboard/StatCard/Feedbacks.svg",
    },
    {
      body: "4000",
      head: "Avg  Response Time",
      icon: "./images/PvxDashboard/StatCard/ResponseTime.svg",
    },
  ];

  return (
    <div className="pvxCustomerSupportColor">
      <Navbar />
      <SideNav active="Support" />
      <div className="pvxCustomerSupport">
        <StatCards statCardData={statCardData} />
        <div className="b2">
          <BigMultiBar title="Queries Received" dropdown={true} />
          <DonutChartBig title="Feedbacks" />
        </div>
        <div className="b2">
          <CustomerTable title="Queries" />
        </div>
      </div>
    </div>
  );
};

export default CustomerSupport;
